t = require('app/scripts/views/internal/teacup-with-helpers')('popover_share')

module.exports = t.renderable ({ hasCsvExport, csvURL, jsonURL, needsUpgradeForCsv, upgradeUrl, hasOrganization, upsellEnabled, isAdDismissed, featureFlag }) ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.a '.js-print', { href: '#', title: t.l('print-using-the-browser-s-print-function-you-can-use-file') }, ->
        t.format 'print-ellipsis'
    if featureFlag
      t.li =>
        if hasCsvExport
          t.a '.js-export', { href: '#' }, ->
            t.format 'export-board'
        else
          t.a '.js-export-json', { href: jsonURL, title: t.l('export-the-board-data-in-json-format') }, ->
            t.format 'export-json'
    else
      t.li =>
        if hasCsvExport
          t.a '.js-export-csv', { href: csvURL, title: t.l('export-the-board-data-in-csv-format') }, ->
            t.format 'export-csv'
        else
          t.a '.disabled', { href: '#', title: t.l('export-the-board-data-in-csv-format') }, ->
            t.format 'export-csv'
            t.div { class: 'export-csv-update-pill', id: 'js-export-csv-pill-update-prompt' }

      t.li ->
        t.a '.js-export-json', { href: jsonURL, title: t.l('export-the-board-data-in-json-format') }, ->
          t.format 'export-json'

    if !hasCsvExport && upsellEnabled
      t.div '.popover-share-ads-container', =>
        t.div '.print-and-export-upgrade-prompt-wrapper'
